
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Le rôle de l’IA dans le marketing digital : applications concrètes",
    description:
      "Découvrez comment l’intelligence artificielle transforme le marketing digital : personnalisation, automatisation et optimisation. ALEO vous aide à tirer parti de ces opportunités.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
